import MicroModal from 'micromodal'
import utils from '../common/util'

const cmpFundsDisclosure = {
  component: null,
  modal: null,
  cookie: {
    name: null, // define in CMS settings?
		value: null,
		expireDays: 1
  },
  decline: false,
  // user: {
  //   region: null,
  //   investorType: null,
  // },
  fund: {
    region: null,
    investorType: null
  },
  init: function (element) {
    const _ = this
    _.component = element
    _.modal = element.querySelector('.modal')
    _.cookie.name = _.component.attributes['data-cookie-name'].value
    _.fund.region = _.component.attributes['data-region'].value
    _.fund.investorType = _.component.attributes['data-investortype'].value

    const fundType = _.fund.region + '-' + _.fund.investorType + '|'
    _.getFundModalCookie()
    if (_.checkAlreadyCookied(fundType)) {
      return
    }

    _.component
      .querySelector('#fundsPopupModal-accept')
      .addEventListener('click', function () {
        _.accept_click(fundType)
      })

    // override all closing mechanisms with decline experience
    const closers = _.component.querySelectorAll(
      '#fundsPopupModal-decline,.cmp-popup-modal__overlay,.cmp-popup-modal__close'
    )
    closers.forEach((el) =>
      el.addEventListener('click', (e) => {
        e.stopPropagation()

        // prevents hidding when clicked on any part of the modal.
        if (el === e.target) {
          _.decline_click(fundType)
        }
      })
    )

    MicroModal.init({
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: false,
      awaitCloseAnimation: false,
      debugMode: false
    })

    MicroModal.show(_.modal.id, {})
  },
  setCookie: function () {
    const _ = this
    utils.cookies.set(_.cookie.name, _.cookie.value, '/', _.cookie.expireDays)
  },
  checkAlreadyCookied: function (fundType) {
    const _ = this
    if (_.cookie.value.indexOf(fundType) > -1) {
      return true
    } else {
      return false
    }
  },
  getFundModalCookie: function () {
    const _ = this
    _.cookie.value = utils.cookies.get(_.cookie.name)
    if (_.cookie.value == null) {
      _.cookie.value = ''
    }
  },
  accept_click: function (fundType) {
    const _ = this
    _.cookie.value += fundType
    _.setCookie()
    _.modal.style.display = 'none'
  },
  decline_click: function () {
    const _ = this
    if (_.declined) {
      return
    }
    _.declined = true

    const regex = /[a-zA-Z]+-[a-zA-Z]+/i // two letters (dash) two letters
    const pathArray = window.location.pathname.split('/')
    const countryCode = pathArray[1]
    const isValidCountryCode = regex.test(countryCode)

    if (isValidCountryCode) {
      window.location.href = '/' + countryCode + '/guest'
    } else {
      window.location.href = '/guest'
    }
  }
}

export default cmpFundsDisclosure
